(function(){
    'use strict'

    angular
    .module('app.cantidades')
    .controller('EditarCantidad', EditarCantidad);

    EditarCantidad.$inject = ['$scope', '$animationsSrv', '$routeParams','CantidadesService', 'logger', '$location'];

    function EditarCantidad($scope, $animationsSrv, $routeParams, CantidadesService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.cantidadId = $routeParams.id ? $routeParams.id : 0;

        getCantidad();

        function getCantidad(){

            if(vm.cantidadId != 0){
                var promise = CantidadesService.getById(vm.cantidadId);

                promise
                .then(function(cantidad){
                    cantidad.esPredeterminado = cantidad.esPredeterminado == 1 ? true : false;
                    cantidad.esFijo = cantidad.esFijo == 1 ? true : false;
                    cantidad.esDestajo = cantidad.esDestajo == 1 ? true : false;
                    vm.cantidad = cantidad;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener la cantidad: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.cantidadForm.$valid){
                if(!vm.cantidad.id){
                    saveCantidad();
                }
                else if($scope.cantidadForm.$dirty){
                    updateCantidad();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveCantidad() {
            
            vm.cantidad.esPredeterminado = vm.cantidad.esPredeterminado ? 1 : 0;
            vm.cantidad.esFijo = vm.cantidad.esFijo ? 1 : 0;
            vm.cantidad.esDestajo = vm.cantidad.esDestajo ? 1 : 0;
            var promise = CantidadesService.save(vm.cantidad);
            
            promise
            .then(function(response){
                logger.success('Cantidad creada con éxito.');
                clearCantidadData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear la cantidad: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateCantidad(){

            vm.cantidad.esPredeterminado = vm.cantidad.esPredeterminado ? 1 : 0;
            vm.cantidad.esFijo = vm.cantidad.esFijo ? 1 : 0;
            vm.cantidad.esDestajo = vm.cantidad.esDestajo ? 1 : 0;
            var promise = CantidadesService.update(vm.cantidad);
            
            promise
            .then(function(response){
                logger.success('Cantidad modificada con éxito.');
                $location.path('/cantidades');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar la cantidad: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearCantidadData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.cantidad = {};
            // Set back to pristine.
            $scope.cantidadForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.cantidadForm.$setUntouched();
        };

    }
})();